<template>
    <fragment>
        <router-view></router-view>
    </fragment>
</template>

<script>

    export default {
        name: 'app',
        watch: {
            /**
             * Watch the route instance
             * @param route
             */
            $route: function (route) {
                // if the route require authentication and not authenticated
                if (!route.meta.public && !this.$store.getters.isAuth) {
                    // redirect to login
                    this.$router.push({name: 'login'});
                }
                // if already authenticated and the route is disabled for authenticated window
                if (this.$store.getters.isAuth && route.meta.disableIfLoggedIn) {
                    // redirect to home
                    this.$router.push({name: 'home'});
                }
            }
        }
    }
</script>

<style lang="scss">
    //Base sass files
    @import "./scss/style.scss";

    .vue-monthly-picker .date-popover {
        z-index: 9999 !important;
        font-size: 13px !important;
    }
</style>
